module.exports = __webpack_public_path__ + "static/media/logo-ylk.png";